export const snakeToCamel = (str) => str.replace(
  /([-_][a-z])/g,
  (group) => group.toUpperCase()
    .replace('-', '')
    .replace('_', '')
)

export const kebabToSnake = (str) => str.replace('-', '_')

export const isFunction = (functionToCheck) => {
  return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]'
}

export const urlToFile = (url, filename, mimeType) => {
  return (fetch(url)
    .then(res => { return res.arrayBuffer() })
    .then(buf => { return new File([buf], filename, { type: mimeType }) })
  )
}

export const diffNow = (time) => {
  const dayjs = require('dayjs')
  const now = dayjs()
  const timeObj = dayjs(time)

  const diffDay = now.diff(timeObj, 'day')
  if (diffDay > 0) return `${diffDay}d ago`
  const diffHour = now.diff(timeObj, 'hour')
  if (diffHour > 0) return `${diffHour}h ago`
  const diffMinute = now.diff(timeObj, 'minute')
  if (diffMinute > 0) return `${diffMinute}m ago`
  const diffSecond = now.diff(timeObj, 'second')
  return `${diffSecond}s ago`
}

export const hexToLuma = (colour) => {
  const hex = colour.replace(/#/, '')
  const r = parseInt(hex.substr(0, 2), 16)
  const g = parseInt(hex.substr(2, 2), 16)
  const b = parseInt(hex.substr(4, 2), 16)

  return [
    0.299 * r,
    0.587 * g,
    0.114 * b
  ].reduce((a, b) => a + b) / 255
}

export const s2ab = (s) => {
  var buf = new ArrayBuffer(s.length) // convert s to arrayBuffer
  var view = new Uint8Array(buf) // create uint8array as viewer
  for (var i = 0;i < s.length;i++) view[i] = s.charCodeAt(i) & 0xFF // convert to octet
  return buf
}
